// src/components/Events/Tree/SnowLayer.jsx

import React from 'react';
import { Box } from '@mui/material';

const SNOW_COUNT = 40;

export default function SnowLayer() {
    const flakes = Array.from({ length: SNOW_COUNT });

    return (
        <Box
            sx={{
                position: 'absolute',
                inset: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
                zIndex: 20, // 트리/장식 위
            }}
        >
            {flakes.map((_, i) => {
                const size = Math.random() * 6 + 4;       // 4~10px
                const left = Math.random() * 100;         // %
                const duration = Math.random() * 10 + 8;  // 8~18s
                const delay = Math.random() * -20;        // 음수로 자연스럽게 시작
                const opacity = Math.random() * 0.6 + 0.3;

                return (
                    <Box
                        key={i}
                        sx={{
                            position: 'absolute',
                            top: '-10%',
                            left: `${left}%`,
                            width: size,
                            height: size,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255,255,255,0.95)',
                            opacity,
                            boxShadow: '0 0 6px rgba(0,0,0,0.25)',  // ✅ 밝은 배경에서도 존재감
                            filter: 'blur(0.4px)',
                            animation: `snow-fall ${duration}s linear infinite`,
                            animationDelay: `${delay}s`,
                        }}
                    />
                );
            })}
        </Box>
    );
}
